<template>
  <div class="selectd-list">
    <div class="list-top">
      <h4>
        已选{{ title }}(<a href="javascript:void(0)">{{ localList.length }}</a
        >)
      </h4>
      <a href="javascript:void(0)" @click="handleClearAll">清除</a>
    </div>
    <section>
      <template v-for="(item, index) in localList">
        <span :key="item[attrKeys.value]" class="select-item">
          <div>{{item|labelFormat(attrKeys.label)}}</div>
          <i style="cursor: pointer; padding-left: 12px" @click="handleClose(index)" >
            <sass-icon type="hi-guanbixiao" />
          </i>
        </span>
      </template>
    </section>
  </div>
</template>
<script>
export default {
  name: 'SelectedList',
  filters: {
    // label 格式化 过滤器
    labelFormat(option = {}, labels = []) {
      // 没有指定字段，直接返回 ”“
      if (!labels) {
        return ''
      } else if (labels.length === 1) {
        // 如果只有一个，则直接获取
        return option[labels[0]]
      } else {
        // 如果有多个，则汇总获取。
        return labels.reduce((prev, cur) => option[prev] + ` ${option[cur]}`)
      }
    }
  },
  props: {
    title: String,
    list: {
      type: [Array, String],
      default() {
        return []
      }
    },
    attrKeys: Object
  },
  computed: {
    localList: {
      get() {
        return this.list
      },
      set(val) {
        this.$emit('update:list', val)
      }
    }
  },
  methods: {
    handleClose(index) {
      const { list } = this
      const delItem = list.splice(index, 1)
      this.localList = list
      this.$emit('del-item', delItem)
    },
    handleClearAll() {
      this.localList = []
      this.$emit('clear-all')
    }
  }
}
</script>
<style lang="less" scoped>
.selectd-list {
  width: 256px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  overflow: hidden;
}
section {
  border: 1px solid #e5e5e5;
  padding: 0 6px;
  height: 408px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.select-item {
  display: inline-block;
  height: 28px;
  max-width: 100%;
  line-height: 28px;
  padding-left: 16px;
  padding-right: 30px;
  border-radius: 24px;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  margin: 10px 6px 0;
  // max-width: 370px;
  position: relative;

  div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  i {
    position: absolute;
    right: 6px;
    top: 4px;
  }
}
.list-top {
  display: flex;
  justify-content: space-between;
  line-height: 22px;
  padding-bottom: 4px;
}
</style>
